// Filtros de los campos numéricos mientras se escribe: lo que no corresponde no llega a escribirse.

/** Cantidades y días: solo dígitos, sin ceros a la izquierda, así que el menor valor posible es 1. */
export function integerInput(value: string): string {
  return value.replace(/\D/g, '').replace(/^0+/, '');
}

/**
 * Montos y porcentajes: solo dígitos y un punto decimal, con hasta 2 decimales. La coma se convierte en punto
 * ("12,5" → "12.5"), como en el teclado numérico de algunos teléfonos.
 */
export function decimalInput(value: string): string {
  const text = value.replace(/,/g, '.').replace(/[^\d.]/g, '');
  const dot = text.indexOf('.');
  const whole = (dot === -1 ? text : text.slice(0, dot)).replace(/^0+(?=\d)/, '');
  if (dot === -1) return whole;
  const decimals = text
    .slice(dot + 1)
    .replace(/\./g, '')
    .slice(0, 2);
  return `${whole === '' ? '0' : whole}.${decimals}`;
}
